<h1 matDialogTitle>Notiz</h1>
<form class="flex flex-col">

    <mat-form-field>
        <mat-label>Notiz</mat-label>
        <textarea cdkTextareaAutosize cdkAutosizeMinRows="5"  [(ngModel)]="text" name="note" matInput (keydown)="submitOnShiftEnter($event)" style="max-height: 70vh"></textarea>
    </mat-form-field>
</form>


<mat-dialog-actions class="flex justify-between w-full">
    <button app-button Inverted mat-dialog-close Color="cancel" >schließen</button>

    <button app-button mat-dialog-close Color="green" (click)="submit()" >speichern</button>
</mat-dialog-actions>
